"use strict";
import Immutable from "immutable";
import _ from "underscore";
export default function(selector) {
  var selectionList = {
    emptyList: Immutable.Set(),
    newList: function(collection) {
      return Immutable.Set(_.map(collection, selector));
    },
    selectAll: function(cursor, collection) {
      cursor.update(_.constant(Immutable.Set(_.map(collection, selector))));
    },
    unselectAll: function(cursor) {
      cursor.update(function(set) {
        return set.clear();
      });
    },
    isSelected: function(cursor, item) {
      return cursor.valueOf().contains(selector(item));
    },
    toggle: function(cursor, item) {
      if (cursor.valueOf().contains(selector(item))) {
        cursor.update(function(set) {
          return set.delete(selector(item));
        });
      } else {
        cursor.update(function(set) {
          return set.add(selector(item));
        });
      }
    },
    react: {
      eventHandlers: function(cursor, collection) {
        return {
          selectAll: _.partial(selectionList.selectAll, cursor, collection),
          unselectAll: _.partial(selectionList.unselectAll, cursor),
          isSelected: _.partial(selectionList.isSelected, cursor),
          toggle: function(item) {
            return _.partial(selectionList.toggle, cursor, item);
          },
          checkboxBindings: function(item) {
            return {
              onChange: _.partial(selectionList.toggle, cursor, item),
              checked: selectionList.isSelected(cursor, item)
            };
          }
        };
      }
    }
  };
  return selectionList;
}
